module.exports = __webpack_public_path__ + "static/media/Rectangle 66.e3c7d360.svg";